module.exports = __webpack_public_path__ + "static/media/kolkata.a2cb1827.svg";